export default __webpack_public_path__ + "static/media/commitSha.e1282b7e.build-env";